module.exports = __webpack_public_path__ + "static/media/Pet Apdoption App UI.3a6ffcd9.png";